module.exports = __webpack_public_path__ + "static/lesson_2-9d6f20582cb026a1f9302282c585d94a.png";